import React, { Component } from 'react'
import Img from 'gatsby-image'
import animateScrollTo from 'animated-scroll-to'
import { FormattedMessage } from 'react-intl'

import './style.sass'

export default class Header extends Component {
  handleChevronIconClick = () => {
    animateScrollTo(document.querySelector('.Main'))
  }

  render() {
    const headerImage = this.props.images.find(
      image => image.node.sizes.src.indexOf('splash') >= 0
    )

    const trianglesArray = Array.from({ length: 50 }, (x, i) => i)

    return (
      <header className="Header">
        <div className="Header__Left">
          <div className="Header__Left__Title">
            <h1>
              <div>
                <FormattedMessage id="header.title.firstLine" />
              </div>
              <div>
                <FormattedMessage id="header.title.secondLine" />
              </div>
              <div>
                <FormattedMessage id="header.title.thirdLine" />
              </div>
              <div>
                <FormattedMessage id="header.title.fourthLine" />
              </div>
            </h1>
          </div>
          <div className="Header__Left__ArrowContainer">
            <button
              className="Header__Left__Arrow"
              onClick={this.handleChevronIconClick}
            >
              <svg
                className="bounce"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 50 50"
              >
                <line x1="2.5" y1="25" x2="25" y2="48" />
                <line x1="25" y1="48" x2="47.5" y2="25" />
              </svg>
            </button>
          </div>
        </div>

        <div className="Header__Right">
          <div className="Header__Triangles__Right">
            {trianglesArray.map((triangle, i) => (
              <div key={i} className="triangle-right" />
            ))}
          </div>

          <div className="Header__Triangles__Down">
            {trianglesArray.map((triangle, i) => (
              <div
                key={i}
                style={{
                  position: 'absolute',
                  top: '-18px',
                  left: `${49 * i}px`,
                  transform: 'rotate(-45deg)',
                }}
                className="triangle-down"
              />
            ))}
          </div>

          <Img
            sizes={headerImage.node.sizes}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
            }}
          />
        </div>
      </header>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/header/index.js